import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "./Sidebar";
import ChatPanel from "./ChatPanel";
import { chat } from "../../services/api";

function ChatApp({ onLogout }) {
  const [conversations, setConversations] = useState([]);
  const [activePhone, setActivePhone] = useState(null);
  const [activeName, setActiveName] = useState("");
  const [unreadTotal, setUnreadTotal] = useState(0);
  const [chatOpen, setChatOpen] = useState(false);

  const fetchConversations = useCallback(async () => {
    try {
      const data = await chat.getConversations();
      setConversations(data.conversations || []);
      setUnreadTotal(data.unread || 0);
    } catch (err) {
      console.error("Failed to fetch conversations:", err);
    }
  }, []);

  useEffect(() => {
    fetchConversations();
    const interval = setInterval(fetchConversations, 3000);
    return () => clearInterval(interval);
  }, [fetchConversations]);

  useEffect(() => {
    document.title = unreadTotal > 0 ? `(${unreadTotal}) CapizFlow` : "CapizFlow";
  }, [unreadTotal]);

  const handleSelectConversation = (phone, name) => {
    setActivePhone(phone);
    setActiveName(name);
    setChatOpen(true);
  };

  const handleBack = () => {
    setChatOpen(false);
    setActivePhone(null);
  };

  const handleNewChat = (phone) => {
    setActivePhone(phone);
    setActiveName(phone);
    setChatOpen(true);
  };

  return (
    <div className={`app-container ${chatOpen ? "chat-open" : ""}`}>
      <Sidebar
        conversations={conversations}
        activePhone={activePhone}
        onSelect={handleSelectConversation}
        onNewChat={handleNewChat}
        onLogout={onLogout}
      />
      <ChatPanel
        phone={activePhone}
        name={activeName}
        onBack={handleBack}
        onConversationUpdate={fetchConversations}
      />
    </div>
  );
}

export default ChatApp;
